import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from './PublicLayout';
import faqs from '../content/publicFaq';
const h=React.createElement;
export default function FaqGrid() {
  const [query,setQuery]=useState('');
  const [category,setCategory]=useState('All questions');
  const categories=['All questions',...new Set(faqs.map(faq=>faq.category))];
  useEffect(()=>{
    const id=window.location.hash.slice(1);
    if(!id)return;
    const target=document.getElementById(id);
    if(target){target.open=true;target.scrollIntoView({block:'start'});}
  },[]);
  const term=query.trim().toLowerCase();
  const filtered=faqs.filter(faq=>(category==='All questions'||faq.category===category)&&
    (faq.question+' '+faq.answer).toLowerCase().includes(term));
  return h(React.Fragment,null,
    h(PageHeader,{eyebrow:'Questions and practical help',title:'A little clarity.',accent:'A smoother next step.',
      intro:'Find help with getting started, signing in, understanding your results and resolving common errors.'}),
    h('section',{className:'emap-container emap-faq-layout'},
      h('aside',{className:'emap-faq-sidebar','aria-label':'FAQ categories'},
        h('p',{className:'emap-eyebrow'},'Find an answer'),
        categories.map(name=>h('button',{type:'button',key:name,onClick:()=>setCategory(name),
          className:'emap-category-button'+(category===name?' is-active':''),'aria-pressed':category===name},name)),
        h('div',{className:'emap-support-card'},h('h2',null,'Still need help?'),
          h('p',null,'Tell us what happened and which account you used.'),
          h(Link,{to:'/contact',className:'emap-text-link'},'Contact EntreMap →'))),
      h('div',{className:'emap-faq-main'},
        h('label',{className:'emap-search-label',htmlFor:'faq-search'},'Search the FAQ'),
        h('input',{id:'faq-search',type:'search',value:query,onChange:e=>setQuery(e.target.value),
          placeholder:'Try “login”, “results” or “403”',className:'emap-search-input'}),
        h('p',{className:'emap-result-count',role:'status','aria-live':'polite'},filtered.length+' questions found'),
        filtered.length===0?h('div',{className:'emap-empty-state'},h('h2',null,'No matching questions'),
          h('p',null,'Try a different search or contact us for help.'),h(Link,{to:'/contact'},'Contact us')):
        [...new Set(filtered.map(faq=>faq.category))].map(name=>
          h('section',{className:'emap-faq-group',key:name,'aria-label':name},h('h2',null,name),
            filtered.filter(faq=>faq.category===name).map(faq=>
              h('details',{key:faq.id,id:'faq-'+faq.id,className:'emap-faq-item'},
                h('summary',null,faq.question,h('span',{'aria-hidden':true},'+')),
                h('div',{className:'emap-faq-answer'},h('p',null,faq.answer),
                  faq.id==='privacy'?h(Link,{to:'/privacypolicy'},'Read the Privacy Policy →'):null))))))));
}

